import mutations from './mutations'
import actions from './actions'
import getters from './getters'
const state = {
    playlists : localStorage.getItem('playlists') && JSON.parse(localStorage.getItem('playlists'))  || [],
    filterResults: ''
};

const module = {
    state,
    getters,
    mutations,
    actions
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/playlists/index.js